import { skipToken } from "@tanstack/query-core";
import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const getPostQueryOptions = ({ postId }: { postId: string | undefined }) =>
  queryOptions({
    queryKey: ["posts", postId],
    queryFn: postId ? () => rpc("getPost", { postId }) : skipToken,
  });
